export default __webpack_public_path__ + "static/media/arrow-right.d2ce79e1.svg";